export default [
  {
    path: "/bot",
    name: "bot",
    component: () => import("@/views/bot/index.vue"),
    meta: {
      resource: "bot",
      title: "breadcrumb.bot",
    },
  },
  {
    path: "/bot/create",
    name: "bot",
    component: () => import("@/views/bot/Create.vue"),
    meta: {
      resource: "chat",
      title: "breadcrumb.bot",
    },
  },
  {
    path: "/bot/:id/update",
    name: "update-bot",
    component: () => import("@/views/bot/Update.vue"),
    meta: {
      resource: "chat",
      title: "breadcrumb.bot",
    },
  },
];
